import React from "react";
import Banner from "../components/case_study/Banner";
import Timeline from "../components/case_study/Timeline";
import MoreCaseStudies from "../components/case_study/MoreCaseStudies";
import ConsultationForm from "../components/product/ConsultationForm";

const CaseStudies = () => {
  return (
    <div>
      <Banner />
      <Timeline />
      <MoreCaseStudies />
      <ConsultationForm />
    </div>
  );
};

export default CaseStudies;